import React from 'react';
import './ApplySection.css';
import Button from '../../components/Button';

export const ApplySection = ({ title, description, buttonLabel, inputPlaceholder }) => {
  return <div className="apply-section">
    <h2>{title}</h2>
    <p className="body-16">
      {description}
    </p>
    <div className="apply-button">
      <div className="filter-bg">
      </div>
      <div className="align-items-stretch apply-button-input-wrapper">
        {
          inputPlaceholder ? 
            <input type="text" placeholder={inputPlaceholder} className="body_dt" />
          : null
        }
        <Button label={buttonLabel} />
      </div>
    </div>
  </div>;
};
